﻿//==========================================================================================================
// Copyright (C) Nore Technology AB. All Rights Reserved.
//==========================================================================================================

//-------------------------------------------------------------------------------------
// Imports
//-------------------------------------------------------------------------------------

//-------------------------------------------------------------------------------------
// State
//-------------------------------------------------------------------------------------

type SetConfirmationCode = { type: "setConfirmationCode"; code: string };
type UpdateError = { type: "setError"; errorMessage: string };
type SetLoading = { type: "setLoading"; nextState?: PageState };
type SetMessageSent = { type: "setPageState"; state: PageState };
type Navigate = { type: "navigate"; uri: string };

export type ConfirmPageViewAction =
    | SetMessageSent
    | UpdateError
    | SetLoading
    | SetConfirmationCode
    | Navigate;

export type PageState = "Default" | "ConfirmMail" | "ConfirmPhone";

interface ConfirmPageState {
    confirmCode: string;
    state: PageState;
    loading: boolean;
    errorMessage: string;
    navigateUri?: string;
}

export function reducer<T>(
    state: ConfirmPageState,
    action: ConfirmPageViewAction
): ConfirmPageState {
    switch (action.type) {
        case "setPageState": {
            return { ...state, state: action.state, loading: false };
        }
        case "setError": {
            return {
                ...state,
                errorMessage: action.errorMessage,
                loading: false,
            };
        }
        case "setLoading": {
            return { ...state, errorMessage: null, loading: true };
        }
        case "setConfirmationCode": {
            return { ...state, confirmCode: action.code, errorMessage: null };
        }
        case "navigate": {
            return { ...state, loading: true, navigateUri: action.uri };
        }
    }
}
